export function isCoinAmount(amount) {
	return amount == 50 || amount == 100 || amount == 200;
}
